import RestService from "~/core/services/rest.service";
import superAdministrationService from "~/modules/superAdministration/services/superAdministration.service";
import type { FetchUserProfileParameters } from "~/modules/user/models/FetchUserProfileParameters.interface";
import type { UserProfile } from "~/modules/user/models/UserProfile.interface";

class UserProfileSuperAdministrationService extends RestService {
  /**
   * Retrieve userProfiles
   */
  getUserProfiles({
    searchParams,
  }: FetchUserProfileParameters): Promise<UserProfile[]> {
    const params = {
      filter: searchParams,
    };

    return this.$apiV2.get(this.getSuperAdministrationProfilesPath(), {
      params,
    });
  }

  private getSuperAdministrationProfilesPath() {
    return `${superAdministrationService.getSuperAdministrationPath()}/profiles`;
  }
}

export default new UserProfileSuperAdministrationService();
